import { Cancel, CheckCircle } from "@mui/icons-material"
import { driverColNm } from "constants/driverConstant"

export const columns = [
  
  {
    field: "No",
    headerName: "No.",
    width: 50,
  },
  {
    field: "IsActv",
    headerName: driverColNm.IsActv,
    width: 60,
    align: "center",
    renderCell: (params) => {
      return params.value===1?<CheckCircle color="success"/>: <Cancel color="action"/>
    }
  },
  {
    field: "DrvCd",
    headerName: driverColNm.DrvCd,
    width: 90,
  },
  {
    field: "Name",
    headerName: driverColNm.FName,
    width: 300,
    valueGetter: ( params ) => `${params.row.FName} ${params.row.LName} (${params.row.NName})`,
  },
  {
    field: "XpssSupCod",
    headerName: "เลขที่ บช. Express",
    flex:200,
    editable: true,
  },
]